import React, { useState, useEffect } from "react";
import style from "./index.module.scss";
import Layout from "../../../layouts/User";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Row, Col } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

export type Props = {};

const breadcrumbs = [
  {
    text: "หน้าแรก",
    path: "/",
  },
  {
    text: "ตะกร้าสินค้า",
    path: "/cart",
  },
  {
    text: "สถานะการชำระเงิน",
    path: "/confirm-cart",
  },
];

const ShoppingConfirm: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = useState<boolean>(false);
  const [orderNumber, setOrderNumber] = useState<string>("");
  const [status, setSatatus] = useState<string>("");
  let [order, setOrder] = useState<any>({});
  let [searchParams, setSearchParams] = useSearchParams();
  const onPaymentClick = () => {
    navigate(`/profile/my-order`);
  };

  const getOrder = async () => {
    const shopProducts = await axios.get(
      `/orders/show-order/${searchParams.get("id")}`
    );
    const shop = shopProducts.data.shops;
    const orderNo = shop[0]?.orderShop?.orderNo ? shop[0]?.orderShop?.orderNo : shop[0]?.orderShop?.order;
    setOrder(shopProducts.data);
    setOrderNumber(orderNo);
  };

  useEffect(() => {
    setPaymentStatus(true);
    // setOrderNumber(order._id);
    // setOrderNumber(orderNo);
    setSatatus(order.status);
  }, [order]);

  useEffect(() => {
    getOrder();
  }, []);

  return (
    <>
      <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
        <Row>
          <Col xs={24} sm={24} md={24} lg={24}>
            <div className={style.CartConfirm}>
              <div style={{ marginTop: "40px" }}>
                <div className={style.IconCart}>
                  {paymentStatus ? (
                    <CheckCircleOutlined />
                  ) : (
                    <CloseCircleOutlined />
                  )}
                </div>
                <div style={{ marginTop: "20px" }}></div>
                {paymentStatus ? (
                  <div className={style.TextConfirm}>แจ้งชำระเงินสำเร็จ</div>
                ) : (
                  <div className={style.TextConfirm}>
                    แจ้งชำระเงินสำเร็จไม่สำเร็จ
                  </div>
                )}
                {!paymentStatus ? (
                  <div className={style.TextCart}>กรุณาชำระเงินภายใน 2 วัน</div>
                ) : (
                  ""
                )}
                {paymentStatus ? (
                  <div className={style.TextCart}>
                    เลขที่คำสั่งซื้อ: {orderNumber}
                  </div>
                ) : (
                  ""
                )}
                {paymentStatus ? (
                  <div className={style.TextCart}>
                    สถานะ: อยู่ระหว่างการตรวจสอบการชำระเงิน
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Col>
        </Row>
        <Row style={{ marginTop: 20 }}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <div className="row">
              <div className={style.addshop}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={onPaymentClick}
                >
                  กลับสู่หน้าหลัก
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Layout>
    </>
  );
};
export default ShoppingConfirm;
